import api from "./api";

let cached = null;

export function getAppConfig() {
  if (!cached) {
    cached = api
      .get("/auth/config")
      .then((r) => r.data)
      .catch(() => ({ direct_login_enabled: true, main_app_url: "https://jobbasket.in" }));
  }
  return cached;
}
